function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.055,
    height: 12,
    viewBox: "0 0 11.055 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11773",
    transform: "translate(-4 -6.129)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 605",
    cx: 1.276,
    cy: 1.276,
    r: 1.276,
    transform: "translate(4 6.129)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 606",
    cx: 1.276,
    cy: 1.276,
    r: 1.276,
    transform: "translate(4 10.83)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 607",
    cx: 1.276,
    cy: 1.276,
    r: 1.276,
    transform: "translate(4 15.578)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3171",
    transform: "translate(7.898 11.68)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7.157v.85H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5574",
    transform: "translate(7.898 16.428)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7.157v.85H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3172",
    transform: "translate(7.898 6.979)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7.157v.85H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletBlue);
export default __webpack_public_path__ + "static/media/BulletBlue.c30e637b2202c246a929b4c14c67ba9d.svg";
export { ForwardRef as ReactComponent };